module.exports = __webpack_public_path__ + "assets/left-arrow.png?7ad67741bc52153726b90b6f69395fb9";